import * as Utils from './../_ws/utils';
import * as Toasts from './toasts';
import * as AddressTypeEnum from './AddressTypeEnum'
import * as InputCheckbox from './input-checkbox';

function bind() {
    InputCheckbox.modernCheckAll();
    const orderSubmitForm = $('#orderSubmitForm');
    const deliveryAndFvForm = $('#deliveryAndFvForm');
    deliveryAndFvForm.find('#customInvoiceData')
        .off('hidden.bs.collapse')
        .off('show.bs.collapse')
        .on('hidden.bs.collapse', function () {
            deliveryAndFvForm.find('#customInvoiceData :input').each(function () {
                $(this).prop('disabled', true);
            });
        })
        .on('show.bs.collapse', function () {
            deliveryAndFvForm.find('#customInvoiceData :input').each(function () {
                $(this).prop('disabled', false);
            });
        });

    orderSubmitForm.find('button')
        .off('click')
        .on('click', function (e) {
            const consentsForm = $('#consentsForm');
            const orderCommentForm = $('#orderCommentForm');
            const externalIdForm = $('#externalIdForm');
            const shipmentRadio = $('[name=shipmentForm]').find('input[name=shipmentKindId]:checked');
            const ProlineOfficesForm = $('#prolineOfficesForm');
            let valid = true;
            let customFvForm = $('#customFvForm');

            // user is not logged in
            if (externalIdForm.length > 0) {
                orderSubmitForm.find('[name=externalId]').val(externalIdForm.find('[name=externalId]').val());
            }

            if(ProlineOfficesForm.length > 0) {
                ProlineOfficesForm.validate().form();
            }

            if (deliveryAndFvForm.length > 0) {
                const isCompanyFvValue = Number.parseInt(deliveryAndFvForm.find('input[name=isCompanyFv]:checked').val() || '0', 10);
                const customFvValue = Number.parseInt(deliveryAndFvForm.find('input[name=customFv]:checked').val() || '-1', 10);
                deliveryAndFvForm.find('#vatInvoiceData :input').each(function () {
                    $(this).prop('disabled', isCompanyFvValue === 0);
                });
                deliveryAndFvForm.find('#customInvoiceData :input').each(function () {
                    $(this).prop('disabled', !(isCompanyFvValue === 0 && customFvValue === 1));
                });

                if (deliveryAndFvForm.validate().form()) {
                    deliveryAndFvForm.find(':input[name]:not(:checkbox):not(:radio):not(:disabled)').each(function () {
                        orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                    });
                    deliveryAndFvForm.find(':checkbox[name]').each(function () {
                        if ($(this).prop("checked")) {
                            orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val(1);
                        } else {
                            orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val(0);
                        }
                    });
                    deliveryAndFvForm.find(':radio[name]').each(function () {
                        if ($(this).prop("checked")) {
                            orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                        }
                    });
                } else {
                    valid = false;
                    Toasts.createToast(['error', 'Proszę uzupełnić dane odbiorcy.']);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('#invoiceData').offset().top
                    }, 500);
                }
                //user is logged
            } else {
                let form = $('body').find('[data-add-shipment=' + $(shipmentRadio).val() + '] .address-card.active form.set-primary');
                if (form.length < 0) {
                    valid = false;
                    Toasts.createToast(['error', 'Proszę wybrać lub wprowadzić dane do dostawy.']);
                }
                //as if he is a normal user
                //check here is there is at least one object in address slider
                const InvoiceBaseRow = $('#' + AddressTypeEnum.INVOICE + 'BaseRow');
                if (customFvForm.length > 0) {
                    if (customFvForm.validate().form()) {
                        customFvForm.find(':checkbox').each(function () {
                            if ($(this).prop("checked")) {
                                orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val(1);
                                if (InvoiceBaseRow.find('.active').length < 1) {
                                    valid = false;
                                    Toasts.createToast(['error', 'Proszę wybrać lub wprowadzić dane do faktury.']);
                                }
                            } else {
                                orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val(0);
                            }
                        });
                    } else {
                        valid = false;
                    }
                    //if he is forced to use custom Fv
                } else {
                    if (InvoiceBaseRow.find('.active').length < 1) {
                        valid = false;
                        Toasts.createToast(['error', 'Proszę wybrać lub wprowadzić dane do faktury.']);
                    }
                }
            }
            //add his comment
            if (orderCommentForm.length > 0) {
                if (orderCommentForm.validate().form()) {
                    orderCommentForm.find(':input[name]:not(:checkbox):not(:radio)').each(function () {
                        orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                    });
                } else {
                    valid = false;
                    Toasts.createToast(['error', 'Błędny komentarz do zamówienia.']);
                }
            }

            if (consentsForm.length > 0) {
                if (consentsForm.validate().form()) {
                    consentsForm.find(':input[type=checkbox]').each(function () {
                        if ($(this).is(':checked')) {
                            orderSubmitForm.find('[name=' + $(this).attr('name') + ']').val($(this).val());
                        }
                    });
                } else {
                    valid = false;
                    Toasts.createToast(['error', 'Zaznacz wymagane zgody.']);
                }
            }

            if (!Utils.isWebsocketReady() || !valid) {
                e.preventDefault();
                e.stopPropagation();
                if (valid) {
                    orderSubmitForm.trigger('submit');
                }
            }
        });
}

function filters() {
    $('#id_of-status-element').off('change').on('change', function (e) {
        $(this).closest('form').trigger('submit');
    });
}

export {
    bind,
    filters,
}
